export const videoReplyKeys = {
  all: () => ['video-reply'],
};
